import React, { useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import "../SettingsSide.css";
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks";
import { ConversationTypeRecord} from "../../../../../store/one-query/conversationType";
import UnarchieveIcon from "../../../../../Custom-imeges/UnarchieveIcon";
import { PersonaType } from "../../../../../Helper";
import TrashIcon from "../../../../../Custom-imeges/TrashIcon";
import { useDeleteConversationType, useUnarchievePersonaType } from "../../../../../store/Apis/ConversationTypeApi";
import PersonaDetails from "./PersonaDetails";
import { Box, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
interface PropsType {
  show: boolean;
  handleClose: () => void;
}
const ArchievedPersonas = ({ show, handleClose }: PropsType) => {
  const dispatch = useAppDispatch();
  const deletePersona = useDeleteConversationType();
  const conversationTypes = useAppSelector((state) => state.ConversationTypes);
  const [selectedPersona, setSelectedPersona] =
    useState<ConversationTypeRecord | null>(null);
  const [isClickingSelectedPersona, setIsClickingSelectedPersona] =
    useState<boolean>(false);
  const UnarchivePersona=useUnarchievePersonaType();
  const handleUnarchievePersona = (persona: ConversationTypeRecord) => {
    if (persona?.id){
    UnarchivePersona(persona?.id);}
  };
  const deleteConversationType = (persona: ConversationTypeRecord) => {
    if (persona?.id) deletePersona(persona?.id);
  };

  const renderTooltip = (Message: string) => (props: any) =>
    (
      <Tooltip className="unarchive-icon-tooltip" {...props}>
        {Message}
      </Tooltip>
    );
 const archivedPersonas = conversationTypes?.data
  ? conversationTypes.data.filter((item: ConversationTypeRecord) => item.isArchived)
  : [];
  return (
    <>
      <Modal
        className="personaModalDelete"
        show={show}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header>
         
            <Box sx={{ display: "flex", alignItems: "center", width:"100%" ,justifyContent:"space-between"}}>
            <Typography className="mb-0" sx={{ fontSize: "14px",color:"var(--Main_icons_color)" }}>
              Archived personas
            </Typography>
            <Close
             onClick={handleClose}
             sx={{ cursor: "pointer", color: "var(--Main_icons_color)" }}
            />
            </Box>
          
        </Modal.Header>
        <Modal.Body className="personaBodyDelete personaArchivedModal px-0">
          <div className="containerFormDelete" style={{padding:"0px 16px", height:"150px",}}>
           
              {archivedPersonas.length > 0 ?
              archivedPersonas.map((persona: ConversationTypeRecord, index: number) => {
                  return (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px",
                        borderRadius: "8px",
                        width:"100%",
                        ":hover": {
                          backgroundColor: "var(--archivedPersonaCardHover)",
                        }
                      }}
                    >
                      <div
                        className={`${
                          persona?.personaType === PersonaType.System
                            ? "sytemPersona"
                            : "userPersona"
                        }`}
                        onClick={() => {
                          setSelectedPersona(persona);
                          setIsClickingSelectedPersona(true);
                        }}
                      >
                        {persona?.title}
                      </div>
                      <div>
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 300 }}
                          overlay={renderTooltip("Unarchive persona")}
                        >
                        <span
                          className="c-pointer"
                          onClick={() => handleUnarchievePersona(persona)}
                        >
                          <UnarchieveIcon className="custom-icon" />
                        </span>
                        </OverlayTrigger>
                        {persona?.personaType === PersonaType.User && (
                           <OverlayTrigger
                           placement="top"
                           delay={{ show: 250, hide: 300 }}
                           overlay={renderTooltip("Delete persona")}
                         >
                          <span
                            className="ms-4 c-pointer"
                            onClick={() => deleteConversationType(persona)}
                          >
                            <TrashIcon className="custom-icon" />
                          </span>
                         </OverlayTrigger>
                        )}
                      </div>
                    </Box>
                  );
                }):(
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    color: "var(--Main_icons_color)",
                    fontSize: "14px",
                    opacity: 0.7,
                  }}
                >
                  No archived personas found.
                </Box>
                )}
          </div>
        </Modal.Body>
      </Modal>
      {isClickingSelectedPersona &&
        selectedPersona?.personaType === PersonaType.User && (
          <PersonaDetails
            show={isClickingSelectedPersona}
            handleClose={() => setIsClickingSelectedPersona(false)}
            PersonaData={selectedPersona}
          />
        )}
    </>
  );
};

export default ArchievedPersonas;